export default {
    data: [],
    paymentMethods: [],
    banks: [],
};



// WEBPACK FOOTER //
// ./src/reports-aggrid/modules/cash-receipts-app/state.js